import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontSize: 16,
    h1: { fontSize: '32px' },
    h4: { fontSize: '16px', fontWeight: '600' },
    body1: { fontSize: '16px' },
    fontFamily: [
      'Helvetica', // System font
      '"Times New Roman"', // System font
      '"Courier New"', // System font
      '"DM Sans"', // Google Font
      'Arial', // Fallback
      'sans-serif' // Fallback
    ].join(',')
  }
});

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: '0px',
    width: '100%',
    height: '100%',
    padding: '44px 64px',
    gap: '16px'
  },
  divider: {
    width: '60px',
    height: '4px',
    backgroundColor: capitalDesignTokens.semanticColors.callToAction.primaryActionMedium
  },
  titleColor: {
    color: capitalDesignTokens.semanticColors.foreground.secondary
  },
  tocContainer: {
    display: 'flex',
    overflow: 'auto',
    width: '100%'
  },
  tocList: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  sectionTitle: {
    paddingY: '8px'
  },
  storyTitle: {
    display: 'flex',
    alignItems: 'baseline',
    paddingY: '4px'
  },
  storyTitleText: {
    flexShrink: 0,
    color: capitalDesignTokens.semanticColors.foreground.secondary
  },
  separator: {
    flex: 1,
    borderBottom: `1px dotted ${capitalDesignTokens.semanticColors.foreground.secondary}`,
    marginX: '4px'
  }
});
